import { render, staticRenderFns } from "./wizardRegForm.vue?vue&type=template&id=79ff0158&scoped=true&"
import script from "./wizardRegForm.vue?vue&type=script&lang=js&"
export * from "./wizardRegForm.vue?vue&type=script&lang=js&"
import style0 from "./wizardRegForm.vue?vue&type=style&index=0&id=79ff0158&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ff0158",
  null
  
)

export default component.exports